import React from 'react';

import Main from '../pages/Main';
import Perfil from '../pages/Perfil';
import IndiqueGanhe from '../pages/IndiqueGanhe';

const routes = [
  {
    path: '/',
    exact: true,
    screen: <Main />,
  },
  {
    path: '/perfil',
    screen: <Perfil />,
  },
  {
    path: '/indique-e-ganhe/:tab?',
    screen: <IndiqueGanhe />,
  },
];

export default routes;
